//*
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get, pick } from 'lodash';

import { INVENTORY_VARIANCE, ROUTE } from '~/constants';
const { MODE, TAB, STATUS } = INVENTORY_VARIANCE;

import * as ivActions from '~/actions/inventoryVarianceActions';
import typeToPermission from '../../../client/helpers/typeToPermissionHelper'

import {
  MainContent,
  MainContentHeader,
  MainContentHeaderButtons,
  MainContentTabs,
} from '~/pages/layout/main-content';
import Breadcrumb from '~/pages/layout/breadcrumb/breadcrumb';
import Overview from './components/overview';

function mapStateToProp(state) {
  const { base = {}, inventoryVariance: pathState = {} } = state;
  const { loading } = base;
  return { loading, pathState };
}

function mapDispatchToProp(dispatch) {
  const actions = {
    ...ivActions,
  };
  return { actions: bindActionCreators(actions, dispatch) };
}

@connect(mapStateToProp, mapDispatchToProp)
export default class ItemTemplate extends Component {

  static contextTypes = {
    currentStore: PropTypes.object,
  };

  static propTypes = {
    actions:   PropTypes.object.isRequired,
    type:      PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    mode:      PropTypes.string.isRequired,
    tab:       PropTypes.string.isRequired,
    storeId:   PropTypes.string.isRequired,
    id:        PropTypes.string,
    loading:   PropTypes.bool,
    pathState: PropTypes.object,
  };
  constructor(props) {
    super(props)
    this.print = this.print.bind(this)
  }
  componentDidMount() {
    const { mode, tab, type, id, actions, pathState = {} } = this.props;
    if (mode !== MODE.NEW || !get(pathState, 'currentStore.id')) {
      actions.initInventoryVariance(this.context.currentStore, id, mode, tab, type);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  edit = (...args) => {
    this.props.actions.startEdit();
  };

  save = () => {
    this.props.actions.saveItem();
  };

  cancelEdit = () => {
    this.props.actions.cancelEdit();
  };

  changeTab = (tab) => {

  };

  void = () => {
    this.props.actions.changeItemStatus('void');
  };

  submit = () => {
    this.props.actions.changeItemStatus('submit');
  };

  cancel = () => {
    this.props.actions.changeItemStatus('cancel');
  };

  reject = () => {
    this.props.actions.changeItemStatus('reject');
  };

  approve = () => {
    this.props.actions.changeItemStatus('approve');
  };

  print() {
    const { currentStore, iv, activeItems, varianceCostTotal } = this.props.pathState
    const storeInfo = ['logo_url', 'title', 'address1', 'address2', 'city']
    const ivInfo = [
      'number', 'name', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt',
      'humanizedType', 'status', 'canceledBy', 'approvedBy', 'rejectedBy',
      'voidedBy', 'effectiveDate',
    ]
    const itemInfo = ['listingBarcode', 'ean13', 'blid', 'bpid', 'productName', 'costBefore',
     'cost', 'varianceCost', 'actualQty', 'totalCost', 'varianceQty', 'serialNumbers', 'qtyBefore']
    const payload = {
      store: pick(currentStore, storeInfo),
      iv: pick(iv, ivInfo),
      items: activeItems.map(item => pick(item, itemInfo)),
      varianceCostTotal
    }

    let fetchUrl;
    let pdfName;
    const domain = 'https://ssr.stg.bindolabs.com/pdf/'
    switch (payload.iv.humanizedType){
      case "Opening":
        fetchUrl = domain + '2';
        pdfName = "Inventory_opening.pdf";
        break;
      case "Adjustment by actual quantity":
        fetchUrl = domain + '3';
        pdfName = "Inventory_qty_adjustment.pdf";
        break;
      case "Adjustment by variance quantity":
        fetchUrl = domain + '4';
        pdfName = "Inventory_Variance_qty_adjustment.pdf";
        break;
      case "Cost adjustment":
        fetchUrl = domain + '5';
        pdfName = "Inventory_cost_adjustment.pdf";
        break;
    }

    function downloadFile(fileName, content){
      const aLink = document.createElement('a');
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(content);
      aLink.click()
    }

    fetch(fetchUrl, {
      method: 'post',
      body: JSON.stringify(payload)
    }).then(r => r.blob()).then(content => {
      downloadFile(pdfName, content)
    })
  }

  render() {
    const { loading, pathState = {} } = this.props;
    const { mode, tab, iv = {}, type } = pathState;
    const { currentStore = {} } = pathState;
    const { status, id: itemId } = iv;
    const isView = mode === MODE.VIEW;
    const isEdit = mode === MODE.EDIT;
    const isNew = mode === MODE.NEW;
    const storeId = get(pathState, 'currentStore.id');
    const title = isNew ? `New Inventory Variance` : `Inventory Variance #${iv.number||''}`;

    const tabsConfig = [
      { label: 'Overview', value: TAB.OVERVIEW },
    ];

    let mainContent = null;
    if (tab === TAB.OVERVIEW) {
      mainContent = <Overview />;
    }

    const btnConfig = [
      {
        content: 'Export PDF',
        permission: '',
        show: isView,
        btnType: 'secondary',
        onClick: this.print,
      },
      {
        content: 'Void',
        permission: '',
        show: isView && (status === STATUS.OPENED || status === STATUS.PENDING_FOR_APPROVAL) && typeToPermission(type, "void", currentStore),
        disabled: !itemId,
        btnType: 'primary',
        onClick: this.void,
      },
      {
        content: 'Submit for Approval',
        permission: '',
        show: isView && status === STATUS.OPENED && typeToPermission(type, "submit", currentStore),
        disabled: !itemId,
        btnType: 'primary',
        onClick: this.submit,
      },
      {
        content: 'Cancel Submission',
        permission: '',
        show: isView && status === STATUS.PENDING_FOR_APPROVAL && typeToPermission(type, "cancel_submission", currentStore),
        disabled: !itemId,
        btnType: 'primary',
        onClick: this.cancel,
      },
      {
        content: 'Reject',
        permission: '',
        show: isView && status === STATUS.PENDING_FOR_APPROVAL && typeToPermission(type, "approval", currentStore),
        disabled: !itemId,
        btnType: 'primary',
        onClick: this.reject,
      },
      {
        content: 'Approve',
        permission: '',
        show: isView && status === STATUS.PENDING_FOR_APPROVAL && typeToPermission(type, "approval", currentStore),
        disabled: !itemId,
        btnType: 'primary',
        onClick: this.approve,
      },
      {
        content: 'Edit',
        permission: '',
        show: isView && status === STATUS.OPENED && typeToPermission(type, "edit", currentStore),
        disabled: !itemId,
        btnType: 'primary',
        onClick: this.edit,
      },
      {
        content: 'Cancel',
        permission: '',
        show: isEdit || isNew,
        disabled: loading,
        btnType: '',
        onClick: this.cancelEdit,
      },
      {
        content: 'Save',
        permission: '',
        show: isEdit || (isNew && typeToPermission(type, "add", currentStore)),
        disabled: loading,
        btnType: 'primary',
        onClick: this.save,
      },
    ];

    return (
      <div className="bp">
        <MainContent>
          <MainContentHeader title={ title }>
            <MainContentHeaderButtons config={ btnConfig } />
          </MainContentHeader>
          <Breadcrumb links={
            [
              { label: 'Stock Take Management' },
              { label: 'Inventory Variance', link: `/v2/${storeId}/${ROUTE.INVENTORY_VARIANCE}` },
              { label: mode === MODE.NEW ? 'New Inventory Variance' : iv.name || `#${iv.number||''}`, active: true },
            ]
          } />
          <MainContentTabs tabs={ tabsConfig } currentTab={ tab } onChange={ this.changeTab } />
          { mainContent }
        </MainContent>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/pages/inventory-variance/item-template.js
 **/